module.exports = __webpack_public_path__ + "static/media/JAP.38f5f77d.webp";